import { ProposalRepository } from '../repositories/proposal.repository'
import { CreateProposalPayload, GetProposalByIdResponseT, GetProposalFilters, GetProposalResponseT } from '../types/proposal.types'

const proposalRepository = new ProposalRepository()

export class ProposalService {
    async getProposal(filters: GetProposalFilters): Promise<GetProposalResponseT> {
        const response = await proposalRepository.getProposal(filters)
        return response.data
    }

    async createProposal(payload: CreateProposalPayload): Promise<void> {
        const response = await proposalRepository.createProposal(payload)
        return response.data
    }

    async getProposalById(proposal_id: number): Promise<GetProposalByIdResponseT> {
        const response = await proposalRepository.getProposalById(proposal_id)
        return response.data
    }

    async updateProposal(proposal_id: number, payload: CreateProposalPayload): Promise<void> {
        const response = await proposalRepository.updateProposal(proposal_id, payload)
        return response.data
    }

    async deleteProposal(proposal_id: number): Promise<void> {
        const response = await proposalRepository.deleteProposal(proposal_id)
        return response.data
    }

    async closeProposal(proposal_id: number): Promise<void> {
        const response = await proposalRepository.closeProposal(proposal_id)
        return response.data
    }
}
